import groupBy from 'lodash/groupBy';

const jemoticons = getJemoticons();
const groupedByCategory = groupBy(jemoticons, 'cat');
const categories = Object.keys(groupedByCategory);
const jemoticonHashmap = categories.reduce((aggregator, category) => {
  const categoryJemoticons = groupedByCategory[category];
  const categoryHashMap = categoryJemoticons.reduce((agg, jemoticon, index) => ({
    // nested reducer:（/｡＼)
    ...agg,
    [`${category}-${index}`]: jemoticon.emo,
  }), {});

  return {
    ...aggregator,
    ...categoryHashMap,
  };
}, {});

export default jemoticonHashmap;

// hoisting ftw ლ(｀ー´ლ)
function getJemoticons() {
  // https://www.jemoticons.com/

  return [{
      emo: "ಠ_ಠ",
      cat: "angry"
  }, {
      emo: "⋋_⋌",
      cat: "angry"
  }, {
      emo: "눈_눈",
      cat: "angry"
  }, {
      emo: "ಠ⌣ಠ",
      cat: "angry"
  }, {
      emo: "ノಠ_ಠノ",
      cat: "angry"
  }, {
      emo: "(¬_¬)",
      cat: "angry"
  }, {
      emo: "(｀Д´)",
      cat: "angry"
  }, {
      emo: "(¬▂¬)",
      cat: "angry"
  }, {
      emo: "(┳◇┳)",
      cat: "angry"
  }, {
      emo: "（▽д▽）",
      cat: "angry"
  }, {
      emo: "(◔ д◔)",
      cat: "angry"
  }, {
      emo: "☜(`o´)",
      cat: "angry"
  }, {
      emo: "(ʘдʘ╬)",
      cat: "angry"
  }, {
  }, {
      emo: "(ಠ ∩ಠ)",
      cat: "angry"
  }, {
      emo: "○几",
      cat: "beg"
  }, {
      emo: "人´∀｀)",
      cat: "beg"
  }, {
     emo: "(￣人￣)",
      cat: "beg"
  }, {
     emo: "(-人-)",
      cat: "beg"
  }, {
      emo: "（＾人＾）",
      cat: "beg"
  }, {
      emo: "(^人^)",
      cat: "beg"
  }, {
     emo: "(人･∀･)",
      cat: "beg"
  }, {
      emo: "(ﾟ∀ﾟ人)",
      cat: "beg"
  }, {
     emo: "(人・ェ・)",
      cat: "beg"
  }, {
      emo: "（－||－）",
      cat: "beg"
  }, {
     emo: "人´･皿･)",
      cat: "beg"
  }, {
     emo: "＠＾▽＾＠",
      cat: "blush"
  }, {
     emo: "(‘-’*)",
      cat: "blush"
  }, {
      emo: "(´∀｀•)",
      cat: "blush"
  }, {
     emo: "(*^_^*)",
      cat: "blush"
  }, {
     emo: "(•ﾟдﾟ•)",
      cat: "blush"
  }, {
      emo: "(*ﾟ∀ﾟ*)",
      cat: "blush"
  }, {
      emo: "(^-^*)ノ",
      cat: "blush"
  }, {
     emo: "(*´ｪ｀*)",
      cat: "blush"
  }, {
      emo: "(*´∀`*)",
      cat: "blush"
  }, {
      emo: "(*ﾟｪﾟ*)",
      cat: "blush"
  }, {
     emo: "(*´∀｀*)",
      cat: "blush"
  }, {
     emo: "(*ﾟｰﾟ)ゞ",
      cat: "blush"
  }, {
     emo: "(*´-｀*)",
      cat: "blush"
  }, {
     emo: "m(＿＿)m",
      cat: "bow"
  }, {
      emo: "＜(。_。)＞",
      cat: "bow"
  }, {
     emo: "<(．＿．)>",
      cat: "bow"
  }, {
      emo: "へ(´д｀へ)",
      cat: "bow"
  }, {
      emo: "o(_ _)o",
      cat: "bow"
  }, {
      emo: "(シ_ _)シ",
      cat: "bow"
  }, {
     emo: "<(＿ ＿)>",
      cat: "bow"
  }, {
      emo: "<(_ _)>",
      cat: "bow"
  }, {
     emo: "(o。_。)o",
      cat: "bow"
  }, {
      emo: "ヾ(_ _。）",
      cat: "bow"
  }, {
     emo: "ｍ（＿　＿）ｍ",
      cat: "bow"
  }, {
      emo: "ｍ（．＿．）ｍ",
      cat: "bow"
  }, {
      emo: "ヾ(＾∇＾)",
      cat: "bye"
  }, {
      emo: "＼(￣O￣)",
      cat: "bye"
  }, {
      emo: "(¬_¬)ﾉ",
      cat: "bye"
  }, {
     emo: "(/・0・)",
      cat: "bye"
  }, {
     emo: "(。･∀･)ﾉ",
      cat: "bye"
  }, {
      emo: "＼(°o°；）",
      cat: "bye"
  }, {
      emo: "川o･-･)ﾉ",
      cat: "bye"
  }, {
      emo: "( ・_・)ノ",
      cat: "bye"
  }, {
     emo: "( ^_^)／",
      cat: "bye"
  }, {
      emo: "( ﾟ▽ﾟ)/",
      cat: "bye"
  }, {
      emo: "(;-_-)ノ",
      cat: "bye"
  }, {
     emo: "(｡´∀｀)ﾉ",
      cat: "bye"
  }, {
     emo: "ヾ(＾-＾)ノ",
      cat: "bye"
  }, {
      emo: "＼(-_- )",
      cat: "bye"
  }, {
      emo: "ヾ(´￢｀)ﾉ",
      cat: "bye"
  }, {
     emo: "ఠ_ఠ",
      cat: "confused"
  }, {
      emo: "◔_◔",
      cat: "confused"
  }, {
     emo: "ಠ_ರೃ",
      cat: "confused"
  }, {
      emo: "℃ↂ_ↂ",
      cat: "confused"
  }, {
      emo: "(⊙_☉)",
      cat: "confused"
  }, {
      emo: "(ﾟｰﾟ;",
      cat: "confused"
  }, {
      emo: "(⊙_◎)",
      cat: "confused"
  }, {
      emo: "(゜-゜)",
      cat: "confused"
  }, {
      emo: "(・・；)",
      cat: "confused"
  }, {
      emo: "⁀⊙﹏☉⁀",
      cat: "confused"
  }, {
      emo: "(・・)",
      cat: "confused"
  }, {
      emo: "（・∩・）",
      cat: "confused"
  }, {
      emo: "(・∧‐)ゞ",
      cat: "confused"
  }, {
      emo: "(⊙＿⊙)",
      cat: "confused"
  }, {
      emo: "(◎_◎;)",
      cat: "confused"
  }, {
      emo: "(●__●)",
      cat: "confused"
  }, {
      emo: "(ﾟヘﾟ)",
      cat: "confused"
  }, {
      emo: "أ‿أ",
      cat: "crying"
  }, {
      emo: "╥﹏╥",
      cat: "crying"
  }, {
      emo: "(;﹏;)",
      cat: "crying"
  }, {
      emo: "(ಥ﹏ಥ)",
      cat: "crying"
  }, {
      emo: "（；へ：）",
      cat: "crying"
  }, {
      emo: "(T＿T)",
      cat: "crying"
  }, {
      emo: "（πーπ）",
      cat: "crying"
  }, {
      emo: "(⋟﹏⋞)",
      cat: "crying"
  }, {
      emo: "（>﹏<）",
      cat: "crying"
  }, {
      emo: "(つ﹏⊂)",
      cat: "crying"
  }, {
      emo: "༼☯﹏☯༽",
      cat: "crying"
  }, {
      emo: "(ノ﹏ヽ)",
      cat: "crying"
  }, {
      emo: "(╥_╥)",
      cat: "crying"
  }, {
      emo: "(༎ຶ⌑༎ຶ)",
      cat: "crying"
  }, {
      emo: "(ಥ_ʖಥ)",
      cat: "crying"
  }, {
     emo: "(≖͞_≖̥)",
      cat: "crying"
  }, {
      emo: "༼ಢ_ಢ༽",
      cat: "crying"
  }, {
      emo: "༼ ༎ຶ ෴ ༎ຶ༽",
      cat: "crying"
  }, {
      emo: "ʕ￫ᴥ￩ʔ",
      cat: "cute"
  }, {
      emo: "└|∵┌|",
      cat: "dancing"
  }, {
      emo: "|┐∵|┘",
      cat: "dancing"
  }, {
      emo: "ヾ(^ ^ゞ",
      cat: "dancing"
  }, {
      emo: "ヾ(^^ゞ)",
      cat: "dancing"
  }, {
      emo: "(ノ^o^)ノ",
      cat: "dancing"
  }, {
      emo: "(ノ￣ー￣)ノ",
      cat: "dancing"
  }, {
      emo: "(ﾉ･o･)ﾉ",
      cat: "dancing"
  }, {
      emo: "(ﾉ≧∀≦)ﾉ",
      cat: "dancing"
  }, {
      emo: "（〜^∇^)〜",
      cat: "dancing"
  }, {
      emo: "(〜￣△￣)〜",
      cat: "dancing"
  }, {
      emo: "〜(꒪꒳꒪)〜",
      cat: "dancing"
  }, {
      emo: "（◞‸◟）",
      cat: "depressed"
  }, {
      emo: "(´∵｀)",
      cat: "depressed"
  }, {
     emo: "从´_υ｀从",
      cat: "depressed"
  }, {
      emo: "(´・ω・｀)",
      cat: "depressed"
  }, {
      emo: "(ｏ´_｀ｏ)",
      cat: "depressed"
  }, {
      emo: "(´･仝･｀)",
      cat: "depressed"
  }, {
      emo: "(´・＿・`)",
      cat: "depressed"
  }, {
      emo: "(_　_|||)",
      cat: "depressed"
  }, {
      emo: "(・∀・)",
      cat: "determined"
  }, {
     emo: "(`･ω･´)",
      cat: "determined"
  }, {
      emo: "ヾ(ﾟｪﾟゞ)",
      cat: "determined"
  }, {
      emo: "(`・ω・´)",
      cat: "determined"
  }, {
      emo: "(+･｀⊇･)b",
      cat: "determined"
  }, {
     emo: "ヾ(｀・ω・´)ノ",
      cat: "determined"
  }, {
      emo: "(｀･ω･´) ｂ",
      cat: "determined"
  }, {
      emo: "（　･`ー･´） +",
      cat: "determined"
  }, {
     emo: "(ન_੦)",
      cat: "disappointed"
  }, {
      emo: "(´д｀)",
      cat: "disappointed"
  }, {
      emo: "つ´Д`)つ",
      cat: "disappointed"
  }, {
      emo: "从´_υ｀从",
      cat: "disappointed"
  }, {
      emo: "(ノ_<。)",
      cat: "disappointed"
  }, {
      emo: "( p_q)",
      cat: "disappointed"
  }, {
      emo: "(´・ω・｀)",
      cat: "disappointed"
  }, {
      emo: "(*ノ_<*)",
      cat: "disappointed"
  }, {
      emo: "(_　_|||)",
      cat: "disappointed"
  }, {
      emo: "Σ(￣ロ￣lll)",
      cat: "disappointed"
  }, {
      emo: "＿ﾉ乙(､ﾝ､)＿",
      cat: "disappointed"
  }, {
      emo: "(＾-＾)＿日",
      cat: "eating"
  }, {
      emo: "(。・・)_且",
      cat: "eating"
  }, {
      emo: "(＃´ー´)旦",
      cat: "eating"
  }, {
      emo: "且_(・_・ )",
      cat: "eating"
  }, {
      emo: "(*´ｪ｀*)っ旦~",
      cat: "eating"
  }, {
     emo: "ಠﭛಠ",
      cat: "evil"
  }, {
      emo: "（｀ー´）",
      cat: "evil"
  }, {
      emo: "` ͜ʖ´",
      cat: "evil"
  }, {
      emo: "ψ`ー´)ﾉ",
      cat: "evil"
  }, {
      emo: "(ʃƪ¬‿¬)",
      cat: "evil"
  }, {
      emo: "(=｀ェ´=)",
      cat: "evil"
  }, {
     emo: "୧⍢⃝୨",
      cat: "excited"
  }, {
      emo: "୧☉□☉୨",
      cat: "excited"
  }, {
     emo: "(´∀`)",
      cat: "excited"
  }, {
      emo: "ʘ ͜ʖ ʘ",
      cat: "excited"
  }, {
      emo: "(≧∇≦*)",
      cat: "excited"
  }, {
      emo: "۹(ÒہÓ)۶",
      cat: "excited"
  }, {
      emo: "(ﾉ･ｪ･)ﾉ",
      cat: "excited"
  }, {
      emo: "٩(^ᴗ^)۶",
      cat: "excited"
  }, {
     emo: "٩(θ‿θ)۶",
      cat: "excited"
  }, {
      emo: "٩(●ᴗ●)۶",
      cat: "excited"
  }, {
     emo: "(๑>ᴗ<๑)",
      cat: "excited"
  }, {
      emo: "ヽ(_ _ヽ)彡",
      cat: "fall"
  }, {
      emo: "_(･＿．)/",
      cat: "fall"
  }, {
      emo: "_:(´ཀ`」 ∠):_",
      cat: "fall"
  }, {
     emo: "εミ(ο_ _)ο",
      cat: "fall"
  }, {
      emo: "ο(_ _ο)彡3",
      cat: "fall"
  }, {
      emo: "(✿◠‿◠)",
      cat: "flower"
  }, {
     emo: "(◠‿◠✿)",
      cat: "flower"
  }, {
      emo: "(◕‿◕✿)",
      cat: "flower"
  }, {
     emo: "(◕__◕✿)",
      cat: "flower"
  }, {
      emo: "(◕‸ ◕✿)",
      cat: "flower"
  }, {
     emo: "(ʘ‿ʘ)ノ✿",
      cat: "flower"
  }, {
      emo: "乁༼☯‿☯✿༽ㄏ",
      cat: "flower"
  }, {
      emo: "❐‿❑",
      cat: "funny"
  }, {
      emo: "ರ_ರ",
      cat: "funny"
  }, {
     emo: "◪_◪",
      cat: "funny"
  }, {
     emo: "◜㍕◝",
      cat: "funny"
  }, {
     emo: "◔̯◔",
      cat: "funny"
  }, {
      emo: "◔_◔",
      cat: "funny"
  }, {
     emo: "أ‿أ",
      cat: "funny"
  }, {
     emo: "(╭ರ_⊙)",
      cat: "glasses"
  }, {
      emo: "(⌐▨_▨)",
      cat: "glasses"
  }, {
      emo: "(つ▀¯▀)つ",
      cat: "glasses"
  }, {
      emo: "༼⌐■ل͟■༽",
      cat: "glasses"
  }, {
      emo: "（´υ｀）",
      cat: "grin"
  }, {
      emo: "(￣▼￣)",
      cat: "grin"
  }, {
     emo: "(・∀・)",
      cat: "grin"
  }, {
     emo: "（*ﾟーﾟ）",
      cat: "grin"
  }, {
      emo: "v(￣∇￣)",
      cat: "grin"
  }, {
      emo: "(´、ゝ｀)",
      cat: "grin"
  }, {
      emo: "（´－｀）ノ",
      cat: "grin"
  }, {
      emo: "(　´_ゝ`)",
      cat: "grin"
  }, {
      emo: "(⊙◞౪◟⊙)",
      cat: "gross"
  }, {
     emo: "ʅ（ ‾⊖◝）ʃ",
      cat: "gross"
  }, {
     emo: "(´ﾟ◞౪◟ﾟ｀)",
      cat: "gross"
  }, {
      emo: "ʅ(◔౪◔ ) ʃ",
      cat: "gross"
  }, {
      emo: "( ☞◔ ౪◔)☞",
      cat: "gross"
  }, {
      emo: "༼;´༎ຶ ༎ຶ༽",
      cat: "gross"
  }, {
     emo: "(´⊙◞⊱◟⊙｀)",
      cat: "gross"
  }, {
     emo: "꒡ꆚ꒡",
      cat: "happy"
  }, {
     emo: "ʘ‿ʘ",
      cat: "happy"
  }, {
      emo: "◉‿◉",
      cat: "happy"
  }, {
      emo: "≖‿≖",
      cat: "happy"
  }, {
      emo: "◙‿◙",
      cat: "happy"
  }, {
      emo: "ȏ.̮ȏ",
      cat: "happy"
  }, {
     emo: "（＾ｖ＾）",
      cat: "happy"
  }, {
      emo: "(´∀`)",
      cat: "happy"
  }, {
      emo: "⊂◉‿◉つ",
      cat: "happy"
  }, {
      emo: "ヽ(ヅ)ノ",
      cat: "happy"
  }, {
     emo: "(¬‿¬)",
      cat: "happy"
  }, {
      emo: "(-‿◦)",
      cat: "happy"
  }, {
      emo: "(•‿•)",
      cat: "happy"
  }, {
      emo: "(─‿─)",
      cat: "happy"
  }, {
      emo: "(◑‿◐)",
      cat: "happy"
  }, {
     emo: "´･ᴗ･`",
      cat: "happy"
  }, {
     emo: "♡＾▽＾♡",
      cat: "heart"
  }, {
      emo: "✿♥‿♥✿",
      cat: "heart"
  }, {
      emo: "♡ඩ⌔ඩ♡",
      cat: "heart"
  }, {
     emo: "(•ө•)♡",
      cat: "heart"
  }, {
     emo: "(✿ ♥‿♥)",
      cat: "heart"
  }, {
     emo: "(｡♥‿♥｡)",
      cat: "heart"
  }, {
      emo: "(●´□`)♡",
      cat: "heart"
  }, {
     emo: "ƪ(♥ﻬ♥)ʃ",
      cat: "heart"
  }, {
     emo: "♥(ˆ⌣ˆԅ)",
      cat: "heart"
  }, {
     emo: "（´・｀ ）♡",
      cat: "heart"
  }, {
     emo: "(ㆆᴗㆆ)",
      cat: "helpless"
  }, {
     emo: "(ﾟ⊿ﾟ)",
      cat: "helpless"
  }, {
     emo: "(´_ゝ`)",
      cat: "helpless"
  }, {
     emo: "(´･_･`)",
      cat: "helpless"
  }, {
      emo: "╮(╯_╰)╭",
      cat: "helpless"
  }, {
      emo: "( º﹃º )",
      cat: "helpless"
  }, {
      emo: "( ˘･з･)",
      cat: "helpless"
  }, {
      emo: "(´ﾟдﾟ`)",
      cat: "helpless"
  }, {
      emo: "┐(´д`)┌",
      cat: "helpless"
  }, {
      emo: "(´,_ゝ`)",
      cat: "helpless"
  }, {
     emo: "Σ(｀L_｀ )",
      cat: "helpless"
  }, {
      emo: "＿ﾉ乙(､ﾝ､)＿",
      cat: "helpless"
  }, {
      emo: "(๑•́ ₃ •̀๑)",
      cat: "helpless"
  }, {
      emo: "(´-ι_-｀)",
      cat: "helpless"
  }, {
     emo: "(・ε・`*) …",
      cat: "helpless"
  }, {
     emo: "ρ(´-＿-｀●)",
      cat: "helpless"
  }, {
      emo: "|_-｡)",
      cat: "hide"
  }, {
     emo: "ﾍ(･_|",
      cat: "hide"
  }, {
     emo: "|ʘ‿ʘ)╯",
      cat: "hide"
  }, {
     emo: "o(・_・)9",
      cat: "hit"
  }, {
      emo: "σ～ (｀´メ",
      cat: "hit"
  }, {
     emo: "|c==(-T )",
      cat: "hit"
  }, {
     emo: "α～(´｀d)",
      cat: "hit"
  }, {
     emo: "☆(ﾟoﾟ(○=(-_-○",
      cat: "hit"
  }, {
     emo: "⊂(◉‿◉)つ",
      cat: "hug"
  }, {
     emo: "⊂(・﹏・⊂)",
      cat: "hug"
  }, {
     emo: "(っಠ‿ಠ)っ",
      cat: "hug"
  }, {
      emo: "ʕっ•ᴥ•ʔっ",
      cat: "hug"
  }, {
     emo: "(っ⇀⑃↼)っ",
      cat: "hug"
  }, {
      emo: "＼(^o^)／",
      cat: "hug"
  }, {
     emo: "(つ▀¯▀)つ",
      cat: "hug"
  }, {
     emo: "ლ(・﹏・ლ)",
      cat: "hug"
  }, {
     emo: "(づ￣ ³￣)づ",
      cat: "hug"
  }, {
      emo: "ლ(´ ❥ `ლ)",
      cat: "hug"
  }, {
     emo: "⊂( ◜◒◝ )⊃",
      cat: "hug"
  }, {
      emo: "(.づ◡﹏◡)づ.",
      cat: "hug"
  }, {
     emo: "⊂(´・ω・｀⊂)",
      cat: "hug"
  }, {
     emo: "⊂((・▽・))⊃",
      cat: "hug"
  }, {
     emo: "ヽ(´o｀；",
      cat: "hurry"
  }, {
     emo: "(￣ー￣;)ゞ",
      cat: "hurry"
  }, {
     emo: "(；´д｀)ゞ",
      cat: "hurry"
  }, {
     emo: "（￣ε￣＠）",
      cat: "kiss"
  }, {
     emo: "(~￣³￣)~",
      cat: "kiss"
  }, {
     emo: "（￣ε￣ʃƪ）",
      cat: "kiss"
  }, {
     emo: "(ಡ艸ಡ)",
      cat: "laughing"
  }, {
      emo: "（⌒▽⌒）",
      cat: "laughing"
  }, {
      emo: "（＾ｖ＾）",
      cat: "laughing"
  }, {
      emo: "(^ц^ )",
      cat: "laughing"
  }, {
     emo: "（≧ｙ≦＊）",
      cat: "laughing"
  }, {
     emo: "（　´∀｀）",
      cat: "laughing"
  }, {
     emo: "( ╹ਊ╹)",
      cat: "laughing"
  }, {
      emo: "( ՞ਊ՞)",
      cat: "laughing"
  }, {
      emo: "(*´∀｀）",
      cat: "laughing"
  }, {
     emo: "( ͡ ͜ʖ ͡ )",
      cat: "lenny-face"
  }, {
      emo: "( ͡~ ͜ʖ ͡°)",
      cat: "lenny-face"
  }, {
      emo: "( ͡ʘ╭͜ʖ╮͡ʘ)",
      cat: "lenny-face"
  }, {
      emo: "( ͡☉ ͜ʖ ͡☉)",
      cat: "lenny-face"
  }, {
      emo: "( ͡⚆ ͜ʖ ͡⚆)",
      cat: "lenny-face"
  }, {
      emo: "( ͡~ ͜ʖ ͡~)",
      cat: "lenny-face"
  }, {
      emo: "( ͡ຈ ͜ʖ ͡ຈ)",
      cat: "lenny-face"
  }, {
      emo: "( ͡° ʖ̯ ͡°)",
      cat: "lenny-face"
  }, {
      emo: "( ͡ಠ ʖ̯ ͡ಠ)",
      cat: "lenny-face"
  }, {
      emo: "( ͠° ͟ʖ ͡°)",
      cat: "lenny-face"
  }, {
      emo: "( ͡° ͜ʖ ͡°)",
      cat: "lenny-face"
  }, {
      emo: "( ͡°╭͜ʖ╮͡° )",
      cat: "lenny-face"
  }, {
      emo: "( ͡^ ͜ʖ ͡^ )",
      cat: "lenny-face"
  }, {
      emo: "( ͡ຈ╭͜ʖ╮͡ຈ )",
      cat: "lenny-face"
  }, {
      emo: "( ͡ᵔ ͜ʖ ͡ᵔ )",
      cat: "lenny-face"
  }, {
      emo: "( ͝סּ ͜ʖ͡סּ)",
      cat: "lenny-face"
  }, {
      emo: "ヽ( ͝° ͜ʖ͡°)ﾉ",
      cat: "lenny-face"
  }, {
      emo: "(ง ° ͜ ʖ °)ง",
      cat: "lenny-face"
  }, {
      emo: "(つ ͡° ͜ʖ ͡°)つ",
      cat: "lenny-face"
  }, {
      emo: "(☞ ͡° ͜ʖ ͡°)☞",
      cat: "lenny-face"
  }, {
      emo: "ᕦ( ͡° ͜ʖ ͡°)ᕤ",
      cat: "lenny-face"
  }, {
      emo: "ᕕ( ͡° ͜ʖ ͡°)ᕗ",
      cat: "lenny-face"
  }, {
      emo: "( ʘ̆ ╭͜ʖ╮ ʘ̆ )",
      cat: "lenny-face"
  }, {
      emo: "( ͡° ͜ʖ ͡°)=ε✄",
      cat: "lenny-face"
  }, {
      emo: "╚═( ͡° ͜ʖ ͡°)═╝",
      cat: "lenny-face"
  }, {
      emo: "┴┬┴┤( ͡° ͜ʖ├┬┴┬",
      cat: "lenny-face"
  }, {
      emo: "(ノ͡° ͜ʖ ͡°)ノ︵┻┻",
      cat: "lenny-face"
  }, {
      emo: "¯\\_( ͠° ͟ʖ °͠ )_/¯",
      cat: "lenny-face"
  }, {
      emo: "╰( ͡° ͜ʖ ͡° )つ──☆*:・ﾟ",
      cat: "lenny-face"
  }, {
      emo: "(∩ ͡ ° ʖ ͡ °) ⊃-(===>",
      cat: "lenny-face"
  }, {
     emo: "༼♥ل͜♥༽",
      cat: "love"
  }, {
     emo: "(´∀｀)♡",
      cat: "love"
  }, {
     emo: "(‘∀’●)♡",
      cat: "love"
  }, {
     emo: "( ˘ ³˘)",
      cat: "love"
  }, {
      emo: "(´ε｀ )♡",
      cat: "love"
  }, {
      emo: "(⺣◡⺣)♡*",
      cat: "love"
  }, {
      emo: "ღゝ◡╹)ノ♡",
      cat: "love"
  }, {
     emo: "★≡≡＼（`△´＼）",
      cat: "magic"
  }, {
      emo: "彡ﾟ◉ω◉ )つー☆*",
      cat: "magic"
  }, {
      emo: "(∩^o^)⊃━☆゜.*",
      cat: "magic"
  }, {
      emo: "(ﾉ◕ヮ◕)ﾉ*:･ﾟ✧",
      cat: "magic"
  }, {
      emo: "(☆_・)・‥…━━━★",
      cat: "magic"
  }, {
      emo: "(∩｀-´)⊃━炎炎炎炎炎",
      cat: "magic"
  }, {
     emo: "炎炎炎炎☆┣o(･ω･ )",
      cat: "magic"
  }, {
     emo: "੭•̀ω•́)੭̸*✩⁺˚",
      cat: "magic"
  }, {
      emo: "( °-°)シ ミ★ ミ☆",
      cat: "magic"
  }, {
     emo: "(ﾉ≧∀≦)ﾉ・‥…━━━★",
      cat: "magic"
  }, {
     emo: "(∩｀-´)⊃━✿✿✿✿✿✿",
      cat: "magic"
  }, {
      emo: "ヽ༼ຈل͜ຈ༽⊃─☆*:・ﾟ",
      cat: "magic"
  }, {
      emo: "( ◔ ౪◔)⊃━☆ﾟ.*・",
      cat: "magic"
  }, {
     emo: "(*’▽’)ノ＾—==ΞΞΞ☆",
      cat: "magic"
  }, {
     emo: "༼つಠ益ಠ༽つ ─=≡ΣO))",
      cat: "magic"
  }, {
      emo: "(つ◕౪◕)つ━☆ﾟ.*･｡ﾟ",
      cat: "magic"
  }, {
      emo: "(*ﾟー^)/'`*:;,．★",
      cat: "magic"
  }, {
      emo: "(∩｀-´)⊃━☆ﾟ.*･｡ﾟ",
      cat: "magic"
  }, {
      emo: "凸ಠ益ಠ)凸",
      cat: "middle-finger"
  }, {
     emo: "凸(¬‿¬)",
      cat: "middle-finger"
  }, {
      emo: "凸(>皿<)凸",
      cat: "middle-finger"
  }, {
      emo: "凸(｀0´)凸",
      cat: "middle-finger"
  }, {
      emo: "凸(｀⌒´メ)凸",
      cat: "middle-finger"
  }, {
      emo: "╭∩╮(⋋‿⋌)ᕗ",
      cat: "middle-finger"
  }, {
      emo: "୧༼◔益◔╭∩╮༽",
      cat: "middle-finger"
  }, {
      emo: "( ︶︿︶)_╭∩╮",
      cat: "middle-finger"
  }, {
      emo: "╭∩╮(ಠಠ)╭∩╮",
      cat: "middle-finger"
  }, {
      emo: "╭∩╮（︶︿︶）╭∩╮",
      cat: "middle-finger"
  }, {
      emo: "╭∩╮◕ل͜◕)╭∩╮",
      cat: "middle-finger"
  }, {
      emo: "凸( •̀_•́ )凸",
      cat: "middle-finger"
  }, {
     emo: "(^_^♪)",
      cat: "music"
  }, {
     emo: "(´0｀)q",
      cat: "music"
  }, {
      emo: "ρ(oμ★)",
      cat: "music"
  }, {
     emo: "♫꒰･◡･๑꒱",
      cat: "music"
  }, {
     emo: "♫♪˙‿˙♫♪",
      cat: "music"
  }, {
     emo: "♪～(￣ε￣)",
      cat: "music"
  }, {
      emo: "♪(´ε｀ )",
      cat: "music"
  }, {
     emo: "⚆ᗝ⚆",
      cat: "nervous"
  }, {
      emo: "●﹏●",
      cat: "nervous"
  }, {
      emo: "⊙﹏⊙",
      cat: "nervous"
  }, {
     emo: "ଵ˛̼ଵ",
      cat: "nervous"
  }, {
     emo: "(๏д๏)",
      cat: "nervous"
  }, {
      emo: "(¤﹏¤)",
      cat: "nervous"
  }, {
     emo: "ミ●﹏☉ミ",
      cat: "nervous"
  }, {
      emo: "(⊃‿⊂)",
      cat: "nervous"
  }, {
     emo: "(꒪⌓꒪)",
      cat: "nervous"
  }, {
     emo: 'ξ"(￣ *)',
      cat: "poop"
  }, {
     emo: "(･･*)ﾉ ⌒ξ",
      cat: "poop"
  }, {
      emo: "(・・*)ノ ⌒ξ",
      cat: "poop"
  }, {
     emo: "(≧∀≦ゞ",
      cat: "roger"
  }, {
     emo: "(｀-´)>",
      cat: "roger"
  }, {
     emo: "(`Д´)ゞ",
      cat: "roger"
  }, {
     emo: "(・∧‐)ゞ",
      cat: "roger"
  }, {
     emo: "(°∀°)ゝ”",
      cat: "roger"
  }, {
     emo: "(＞Д＜)ゝ”",
      cat: "roger"
  }, {
     emo: "(｀∀´)ゝ”",
      cat: "roger"
  }, {
     emo: "_/￣|(冫、)-c",
      cat: "roll"
  }, {
    emo: "ᕕ( ᐛ )ᕗ",
      cat: "running"
  }, {
      emo: "ᕕ(ಥʖ̯ಥ)ᕗ",
      cat: "running"
  }, {
      emo: "ᕕ( ಠ‿ಠ)ᕗ",
      cat: "running"
  }, {
      emo: "ᕕ༼✪ل͜✪༽ᕗ",
      cat: "running"
  }, {
      emo: "┌( ಠ‿ಠ)┘",
      cat: "running"
  }, {
     emo: "ᕕ(╯°□°)ᕗ",
      cat: "running"
  }, {
     emo: "┌( ಠ_ಠ)┘",
      cat: "running"
  }, {
      emo: "٩(•౪•٩)三",
      cat: "running"
  }, {
     emo: "ᕕ( ◔3◔)ᕗ",
      cat: "running"
  }, {
     emo: "｡｡゛(ﾉ><)ﾉ",
      cat: "running"
  }, {
      emo: "ε＝（ﾉﾟдﾟ）ﾉ",
      cat: "running"
  }, {
     emo: "ε≡(ノ´＿ゝ｀）ノ",
      cat: "running"
  }, {
     emo: "⊙︿⊙",
      cat: "sad"
  }, {
      emo: "ಠ⌣ಠ",
      cat: "sad"
  }, {
      emo: "╥﹏╥",
      cat: "sad"
  }, {
      emo: "ಥ_ಥ",
      cat: "sad"
  }, {
      emo: "●︿●",
      cat: "sad"
  }, {
     emo: "ಠ╭╮ಠ",
      cat: "sad"
  }, {
      emo: "(ㄒoㄒ)",
      cat: "sad"
  }, {
     emo: "(︶︹︺)",
      cat: "sad"
  }, {
     emo: "(╥_╥)",
      cat: "sad"
  }, {
      emo: "(T⌓T)",
      cat: "sad"
  }, {
      emo: "（´＿｀）",
      cat: "sad"
  }, {
      emo: "(T＿T)",
      cat: "sad"
  }, {
     emo: "(ಥ﹏ಥ)",
      cat: "sad"
  }, {
      emo: "(个_个)",
      cat: "sad"
  }, {
      emo: "(⋟﹏⋞)",
      cat: "sad"
  }, {
      emo: "(ノ﹏ヽ)",
      cat: "sad"
  }, {
     emo: "（πーπ）",
      cat: "sad"
  }, {
      emo: "(◕︿◕✿)",
      cat: "sad"
  }, {
      emo: "(つ﹏<。)",
      cat: "sad"
  }, {
     emo: "(´∀｀ゞ",
      cat: "salute"
  }, {
     emo: "(￣ー￣)ゞ",
      cat: "salute"
  }, {
     emo: "(‘-‘*ゞ",
      cat: "salute"
  }, {
     emo: "(￣^￣)ゞ",
      cat: "salute"
  }, {
     emo: "（・д・ゝ）",
      cat: "salute"
  }, {
     emo: "(￣▽￣)ゞ",
      cat: "salute"
  }, {
     emo: "(^-^)ゝ",
      cat: "salute"
  }, {
      emo: "(‘∀`)ゞ",
      cat: "salute"
  }, {
     emo: "('-'*ゞ",
      cat: "salute"
  }, {
     emo: "(ノдヽ)",
      cat: "scared"
  }, {
      emo: "(⊃‿⊂)",
      cat: "scared"
  }, {
     emo: "(／。＼)",
      cat: "scared"
  }, {
     emo: "（／_＼）",
      cat: "scared"
  }, {
     emo: "(/;◇;)/",
      cat: "scared"
  }, {
     emo: "(￣■￣;)",
      cat: "shocked"
  }, {
     emo: "(ʘᗩʘ’)",
      cat: "shocked"
  }, {
     emo: "(ʘ言ʘ╬)",
      cat: "shocked"
  }, {
     emo: "（*￣□￣*；",
      cat: "shocked"
  }, {
     emo: "(∩╹□╹∩)",
      cat: "shocked"
  }, {
     emo: "＝(￣□￣;)⇒",
      cat: "shocked"
  }, {
      emo: "┐(´д｀)┌",
      cat: "shrug"
  }, {
      emo: "┐(´～｀)┌",
      cat: "shrug"
  }, {
      emo: "┐(´ー｀)┌",
      cat: "shrug"
  }, {
      emo: "┐(￣ヘ￣)┌",
      cat: "shrug"
  }, {
      emo: "╮(╯_╰)╭",
      cat: "shrug"
  }, {
     emo: "┐(´∀｀)┌",
      cat: "shrug"
  }, {
      emo: "ʅ(́◡◝)ʃ",
      cat: "shrug"
  }, {
     emo: "┐(ﾟ～ﾟ)┌",
      cat: "shrug"
  }, {
     emo: "ლ(ಠ益ಠ)ლ",
      cat: "shrug"
  }, {
      emo: "┐(‘～`;)┌",
      cat: "shrug"
  }, {
      emo: "ヘ(´－｀;)ヘ",
      cat: "shrug"
  }, {
      emo: "┐( -“-)┌",
      cat: "shrug"
  }, {
      emo: "乁༼☯‿☯✿༽ㄏ",
      cat: "shrug"
  }, {
      emo: "ʅ（´◔౪◔）ʃ",
      cat: "shrug"
  }, {
     emo: "ヽ(゜～゜o)ノ",
      cat: "shrug"
  }, {
     emo: "┐(-。ー;)┌",
      cat: "shrug"
  }, {
      emo: "¯\\_(ツ)_/¯",
      cat: "shrug"
  }, {
      emo: "¯\\_(⊙_ʖ⊙)_/¯",
      cat: "shrug"
  }, {
      emo: "¯\\_༼ ಥ ‿ ಥ ༽_/¯",
      cat: "shrug"
  }, {
      emo: "乁( ⁰͡  Ĺ̯ ⁰͡ ) ㄏ",
      cat: "shrug"
  }, {
     emo: "（/｡＼)",
      cat: "shy"
  }, {
     emo: "ʕ*ﾉᴥﾉʔ",
      cat: "shy"
  }, {
     emo: "ꈍ .̮ ꈍ",
      cat: "shy"
  }, {
     emo: "( 〃．．)",
      cat: "shy"
  }, {
     emo: "【:εω",
      cat: "sleep"
  }, {
      emo: "(冫༵、)",
      cat: "sleep"
  }, {
      emo: "(ᴗ˳ᴗ)",
      cat: "sleep"
  }, {
      emo: "(´～`)",
      cat: "sleep"
  }, {
      emo: "( ⓥωⓥ)",
      cat: "sleep"
  }, {
      emo: "(:˒[￣]",
      cat: "sleep"
  }, {
     emo: "(︶｡︶✽)",
      cat: "sleep"
  }, {
     emo: "(¦ꒉ[▓▓]",
      cat: "sleep"
  }, {
     emo: "＿ﾉ乙(､ﾝ､)＿",
      cat: "sleep"
  }, {
      emo: "（´○｀）～ゝ",
      cat: "sleep"
  }, {
     emo: "＼（´Ｏ｀）／",
      cat: "sleep"
  }, {
     emo: "(｡v_v｡)",
      cat: "sleep"
  }, {
      emo: "(๑ᵕ⌓ᵕ̤)",
      cat: "sleep"
  }, {
     emo: "(´∀｀）",
      cat: "smiling"
  }, {
      emo: "（＾∀＾）",
      cat: "smiling"
  }, {
      emo: "(^○^)",
      cat: "smiling"
  }, {
      emo: "(｀▽´)",
      cat: "smiling"
  }, {
     emo: "(∩_∩)",
      cat: "smiling"
  }, {
     emo: "(￣∇￣)",
      cat: "smiling"
  }, {
     emo: "(*´ー`)",
      cat: "smiling"
  }, {
     emo: "(*´∇｀*)",
      cat: "smiling"
  }, {
     emo: "(=^_^=)",
      cat: "smiling"
  }, {
     emo: "(￣^￣)",
      cat: "smug"
  }, {
      emo: "(-、-)",
      cat: "smug"
  }, {
     emo: "（￣へ￣）",
      cat: "smug"
  }, {
      emo: "（￣＾￣）",
      cat: "smug"
  }, {
     emo: "( ´ｰ`)",
      cat: "smug"
  }, {
      emo: "（；￣︶￣）",
      cat: "smug"
  }, {
      emo: "(￣︶￣;)",
      cat: "smug"
  }, {
     emo: "(ｰ ｰ;)",
      cat: "sulk"
  }, {
      emo: "(´･･`)",
      cat: "sulk"
  }, {
      emo: "(ó﹏ò｡)",
      cat: "sulk"
  }, {
     emo: "…φ(。。*)",
      cat: "sulk"
  }, {
     emo: "(´･_･｀)",
      cat: "sulk"
  }, {
     emo: "(´･ｪ･｀)",
      cat: "sulk"
  }, {
     emo: "⊙▂⊙",
      cat: "surprised"
  }, {
     emo: "（´〇｀）",
      cat: "surprised"
  }, {
     emo: "(・о・)",
      cat: "surprised"
  }, {
     emo: "（○□○）",
      cat: "surprised"
  }, {
     emo: "( ﾟoﾟ)",
      cat: "surprised"
  }, {
     emo: "(°o°:)",
      cat: "surprised"
  }, {
      emo: "(・・；)",
      cat: "sweat"
  }, {
      emo: "(￣ー￣；",
      cat: "sweat"
  }, {
     emo: "(-。－；)",
      cat: "sweat"
  }, {
      emo: "(･Θ･;)",
      cat: "sweat"
  }, {
      emo: "(;￣ー￣川",
      cat: "sweat"
  }, {
     emo: "（;￣ー￣A",
      cat: "sweat"
  }, {
     emo: "┬─┬ノ(ಠ_ಠノ)",
      cat: "table-flip"
  }, {
     emo: "(ﾉ｀□´)ﾉ⌒┻━┻",
      cat: "table-flip"
  }, {
     emo: "(╯ಠ_ಠ）╯︵ ┳━┳",
      cat: "table-flip"
  }, {
     emo: "(╯ಠ‿ಠ)╯︵┻━┻",
      cat: "table-flip"
  }, {
     emo: "(╯=▃=)╯︵┻━┻",
      cat: "table-flip"
  }, {
     emo: "(ﾉಠдಠ)ﾉ︵┻━┻",
      cat: "table-flip"
  }, {
     emo: "(ノ-_-)ノ~┻━┻",
      cat: "table-flip"
  }, {
     emo: "┬───┬ ノ༼ຈل͜ຈノ༽",
      cat: "table-flip"
  }, {
      emo: "(ノ͡° ͜ʖ ͡°)ノ︵┻┻",
      cat: "table-flip"
  }, {
     emo: "┬━┬ノ(▀̿̿Ĺ̯̿̿▀̿ ̿ノ)",
      cat: "table-flip"
  }, {
     emo: "σﾟﾛﾟ)σ",
      cat: "thats-it"
  }, {
      emo: "(´ー`)σ",
      cat: "thats-it"
  }, {
     emo: "(σﾟ∀ﾟ)σ",
      cat: "thats-it"
  }, {
     emo: "( ￣ー￣)σ",
      cat: "thats-it"
  }, {
     emo: "(☞ ͡° ͜ʖ ͡°)☞",
      cat: "thats-it"
  }, {
      emo: "(つ ͡° ͜ʖ ͡°)つ",
      cat: "thats-it"
  }, {
      emo: "(＾＾)ｂ",
      cat: "thumbs-up"
  }, {
     emo: "（´∀`）ｂ",
      cat: "thumbs-up"
  }, {
      emo: "(￣ー￣)ｂ",
      cat: "thumbs-up"
  }, {
     emo: "(￣ε￣〃)ｂ",
      cat: "thumbs-up"
  }, {
      emo: "d(ﾟｰﾟ@)",
      cat: "thumbs-up"
  }, {
     emo: "b(￣▽￣*)",
      cat: "thumbs-up"
  }, {
      emo: "(*￣▽￣)d",
      cat: "thumbs-up"
  }, {
     emo: "╭( ･ㅂ･)و",
      cat: "thumbs-up"
  }, {
     emo: "＿ﾉフ○",
      cat: "tired"
  }, {
      emo: "(￣Д￣",
      cat: "tired"
  }, {
     emo: "（－－；",
      cat: "tired"
  }, {
      emo: "（´。｀)",
      cat: "tired"
  }, {
      emo: "（￣Ω￣）",
      cat: "tired"
  }, {
     emo: "（´・｀）",
      cat: "tired"
  }, {
     emo: "(-。-;",
      cat: "tired"
  }, {
      emo: "(´Д｀)",
      cat: "tired"
  }, {
      emo: "(;´Д｀)",
      cat: "tired"
  }, {
     emo: "（´＿｀;）",
      cat: "tired"
  }, {
      emo: "（；￣д￣）",
      cat: "tired"
  }, {
     emo: "(´ヘ｀;)",
      cat: "tired"
  }, {
      emo: "(;・・;)",
      cat: "tired"
  }, {
     emo: "o(｀^´*)",
      cat: "try-my-best"
  }, {
     emo: "(〃-ー-)ﾉ",
      cat: "try-my-best"
  }, {
      emo: "(*・`д・)",
      cat: "try-my-best"
  }, {
     emo: "(´_¨｀)9",
      cat: "try-my-best"
  }, {
     emo: "╭( ･ㅂ･)و",
      cat: "try-my-best"
  }, {
     emo: "(๑˃̵ᴗ˂̵)و",
      cat: "try-my-best"
  }, {
     emo: "(ง •̀ω•́)ง✧",
      cat: "try-my-best"
  }, {
      emo: "( •̀ᄇ• ́)ﻭ✧",
      cat: "try-my-best"
  }, {
     emo: "（´＊｀）",
      cat: "vomit"
  }, {
     emo: "（＾～＾）",
      cat: "vomit"
  }, {
     emo: "( -.-)",
      cat: "vomit"
  }, {
     emo: "（･□･）川",
      cat: "vomit"
  }, {
     emo: "＿|￣|○､;",
      cat: "vomit"
  }, {
     emo: "〠_〠",
      cat: "weird"
  }, {
      emo: "༎ຶ‿༎ຶ",
      cat: "weird"
  }, {
     emo: "( ఠൠఠ )",
      cat: "weird"
  }, {
     emo: "༼▃ Ĺ̯ ▃༽",
      cat: "weird"
  }, {
     emo: "ಠ‿↼",
      cat: "wink"
  }, {
     emo: "(・_＋)",
      cat: "wink"
  }, {
     emo: "(^_-)",
      cat: "wink"
  }, {
     emo: "(^_−)☆",
      cat: "wink"
  }, {
     emo: "(ﾉ･_-)☆",
      cat: "wink"
  }];
}



// WEBPACK FOOTER //
// ./src/data/jemoticons.js